/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { PntSegmentsControllerGetScreenbugByDateQueryResponse, PntSegmentsControllerGetScreenbugByDatePathParams, PntSegmentsControllerGetScreenbugByDateQueryParams } from "../models/PntSegmentsControllerGetScreenbugByDate";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { pntSegmentsControllerGetScreenbugByDate } from "../axios/pntSegmentsControllerGetScreenbugByDate";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const pntSegmentsControllerGetScreenbugByDateQueryKey = (slug: PntSegmentsControllerGetScreenbugByDatePathParams["slug"], params: PntSegmentsControllerGetScreenbugByDateQueryParams) => ["api-v2", { url: '/pnt/v2/segments/:slug/screenbug', params: {slug:slug} }, ...(params ? [params] : [])] as const

export type PntSegmentsControllerGetScreenbugByDateQueryKey = ReturnType<typeof pntSegmentsControllerGetScreenbugByDateQueryKey>

export function pntSegmentsControllerGetScreenbugByDateQueryOptions(slug: PntSegmentsControllerGetScreenbugByDatePathParams["slug"], params: PntSegmentsControllerGetScreenbugByDateQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = pntSegmentsControllerGetScreenbugByDateQueryKey(slug, params)
        return queryOptions<PntSegmentsControllerGetScreenbugByDateQueryResponse, ResponseErrorConfig<Error>, PntSegmentsControllerGetScreenbugByDateQueryResponse, typeof queryKey>({
         enabled: !!(slug&& params),
         queryKey,
         queryFn: async ({ signal }) => {
            return pntSegmentsControllerGetScreenbugByDate(slug, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Retrieve the screenbugs for a given time range
 * {@link /pnt/v2/segments/:slug/screenbug}
 */
export function usePntSegmentsControllerGetScreenbugByDate<TData = PntSegmentsControllerGetScreenbugByDateQueryResponse, TQueryData = PntSegmentsControllerGetScreenbugByDateQueryResponse, TQueryKey extends QueryKey = PntSegmentsControllerGetScreenbugByDateQueryKey>(slug: PntSegmentsControllerGetScreenbugByDatePathParams["slug"], params: PntSegmentsControllerGetScreenbugByDateQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<PntSegmentsControllerGetScreenbugByDateQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? pntSegmentsControllerGetScreenbugByDateQueryKey(slug, params)
         

         const query = useQuery({
          ...pntSegmentsControllerGetScreenbugByDateQueryOptions(slug, params, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}